import { render } from "./ProgramDetails.vue?vue&type=template&id=6010df20"
import script from "./ProgramDetails.vue?vue&type=script&lang=js"
export * from "./ProgramDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__